
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import {fetchOrders,fetchConfirmedOrders,fetchPendingOrders} from '../../../api/api';
import { fetchNotifications,sendEmailNotification} from "../../../api/api"; 
import { getStatusValues} from "../../../api/api"; 

import moment from 'moment';
import { fetchOrderToEdit } from '../../../api/api';
import { fetchCompany } from "../../../api/api";  



interface OrderType {
  discountAmt: string;
  taxAmt: string;
  total: string;
  net: number;
  discount: number;
  tax: number;
  rate: string;
  qty: string;
  name: string;
  BillNo: number;
  BillPartyName: string;
  BillDate: string;
  BillNetTotalField: number;
  status?: string; 
}

interface Item {
  amount: any;
  unitPrice: any;
  description: any;
  quantity: any;
  itemCode: any;
  ThirdCost: any;
  ThirdRate1: any;
  SecCostRate: any;
  SecRetailRate: any;
  ThirdUnit: any;
  SecUnit: string;
  Company: string;
  Typ: string;
  ItemC: string;
  code: string;
  Cost: any;
  ExpiryTextField: string;
  BatchTextField: string;
  MRP: any;
  UnitName: string;
  Pack: any;
  ItemNameTextField: string;
  Rate1: number;
  Tax1: number;
}

interface OrderRow {
  name: string;
  rate: string;
  tax: string;
  code: string;
  qty: string;
  discount: string;
  discountAmt: string;
  total: string;
  taxAmt: string;
  net: string;
  godown: string;
  pack: string;
  unit: string;
  cost: string;
  batch: string;
  mrp: string;
  expiry: string;
}
interface Company {
  company_name: string;
  address_english: string;
  cr_no: string;
  vat_no: string;
  mobile: string;
  bank_name: string;
  account_name: string;
  account_number: string;
  iban: string;
  logo?: string;
  logoUrl?: string; 
}


const Order = () => {
   const { t } = useTranslation();
  const [orders, setOrders] = useState<OrderType[]>([]);
  const [filter, setFilter] = useState<string>('all');
  const navigate = useNavigate();

  //states for email notification status yes or no
  const [receiverEmail, setReceiverEmail] = useState('');
const [emailNotification, setEmailNotification] = useState(false);

const [masterData, setMasterData] = useState({
  invno: "",
  date: "",
  customerName: "",
  customerId: "", 
  totalAmount: "",
   disc_amt: "",
  disc_perc: "",
  tax_perc: "",
  trans_charge: "",
  tot_qty: "",
  tot_tot:"",
  tot_tax_amt:"",
  contact:"",
  tax_amt:"",
  ln_disc_tot:"",
  // vehicle:"",
});

const [invoiceNo, setInvoiceNo] = useState<string>("");// state for invoice number
const [discountAmt, setDiscountAmt] = useState(0);//  states for discount fields
const [discountPerc, setDiscountPerc] = useState(0);
const [summaryDiscPercAmt, setSummaryDiscPercAmt] = useState(''); //dis perc amt

//get comapny logog details,
const [company, setCompany] = useState<Company | null>(null);
// selected party (for masterData)
const [selectedPartyName, setSelectedPartyName] = useState<string>("");
const [selectedPartyId, setSelectedPartyId] = useState<string>("");
const [date, setDate] = useState(moment().format('YYYY-MM-DD'));

const totalTotal = orders.reduce((sum, row) => sum + (Number(row.total) || 0), 0);
const totalTaxAmt = orders.reduce((sum, row) => sum + (Number(row.taxAmt) || 0), 0);
const totalNet = orders.reduce((sum, row) => sum + (Number(row.net) || 0), 0);
const totalDiscountAmt = orders.reduce((sum, row) => sum + (Number(row.discountAmt) || 0), 0);



  const loadOrders = async () => {
    try {
      let data: OrderType[] = [];

      if (filter === 'confirmed') {
        data = await fetchConfirmedOrders();
      } else if (filter === 'pending') {
        data = await fetchPendingOrders();
      } else {
        data = await fetchOrders();
      }

      if (Array.isArray(data)) {
        setOrders(data);
      } else {
        console.error('Invalid orders data:', data);
        setOrders([]);
      }
    } catch (error) {
      console.error('Error loading orders:', error);
      setOrders([]);
    }
  };

  useEffect(() => {
    loadOrders();
  }, [filter]);

  const handleFilterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFilter(e.target.value);
  };
  //notifications
    useEffect(() => {
    const loadNotifications = async () => {
      try {
        const data = await fetchNotifications();
        console.log("Notifications:", data);
  
        //  Example: you can display them, or trigger alerts
        data.forEach((notification: any) => {
          
          console.log(" New Notification:", notification.event_title);
        });
  
      } catch (err) {
        console.error("Failed to fetch notifications:", err);
      }
    };
  
    loadNotifications();
  }, []);
//email
// useEffect(() => {
//   const triggerEmails = async () => {
//     try {
      
//       const result = await sendEmailNotification("musthahsin@proton.me", "Event Reminder", "Reminder: Event scheduled on 2023-06-01");
//       console.log("Email notifications processed:", result);
//     } catch (err) {
//       console.error("Failed to send event emails:", err);
//     }
//   };

//   triggerEmails();
// }, []);


useEffect(() => {
  const triggerEmails = async () => {
    try {
      //Get status from backend
      const statusData = await getStatusValues();
      const status = statusData?.[0]?.email_status; // "yes" or "no"

      // Only send email if status is "yes"
      if (status === "yes") {
        const result = await sendEmailNotification(); 
        console.log("Email notifications processed:", result);
      } else {
        console.log("Email notifications not sent. Status is 'no'.");
      }
    } catch (err) {
      console.error("Failed to process email notifications:", err);
    }
  };

  triggerEmails();
}, []);


//statusof email yes or no
useEffect(() => {
  const getStatus = async () => {
    try {
      const status = await getStatusValues();
      console.log("Status values:", status);
    } catch (err) {
      console.error("Failed to get status values:", err);
    }
  };

  getStatus();
}, []);
                
//to fetch company details for printing
useEffect(() => {
  const loadCompany = async () => {
    try {
      const data = await fetchCompany();
      const comp = data?.[0];

      if (comp) {
        let logoUrl = '';
        try {
          const parsedLogo = comp.logo ? JSON.parse(comp.logo) : null;
          logoUrl = parsedLogo?.img || '';
        } catch (err) {
          console.warn('Error parsing logo JSON:', err);
        }

        const companyMapped: Company = {
          company_name: comp.Name,
          address_english: comp.Place,
          cr_no: comp.Add2,
          vat_no: comp.tax?.toString() || '',
          mobile: comp.Ph,
          bank_name: comp.bank,
          account_name: comp.beneficiary,
          account_number: comp.account_no,
          iban: '',
          logoUrl, 
        };

        setCompany(companyMapped);
      }
    } catch (err) {
      console.error("Error loading company:", err);
    }
  };
  loadCompany();
}, []);


const handlePrint = async (e: React.MouseEvent, BillNo: number) => {
  e.stopPropagation();

  try {
    console.log("FETCHING ORDER FOR PRINT:", BillNo);

    // Fetch full order details from backend
    const data = await fetchOrderToEdit(String(BillNo));

    if (!data || !data.master || data.master.length === 0) {
      alert("No printable data found.");
      return;
    }

    const master = data.master[0];  // master details (header totals etc.)
    const items = data.table || []; // table rows (products)

    console.log("MASTER:", master);
    console.log("ITEMS:", items);

    // Extract required fields
    const selectedPartyName = master.BillPartyName || "";
    const invoiceNo = BillNo;
    const date = master.BillDate || "";
    const contact = master.contact || "";
    const totalTotal = Number(master.BillTotalField || 0);
    const totalDiscountAmt = Number(master.BillDiscAmtField || 0);
    const netAmount = Number(master.BillNetTotalField || 0);
    const totalTaxAmt = Number(master.TaxAmt || 0);
    const totalNet = Number(master.BillNetTotalField || 0);

    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    

    printWindow.document.write(`
      <html>
        <head>
          <title>Quotation</title>
        </head>
        <body style="font-family: Arial, sans-serif; font-size: 13px; margin: 20px;">

          <!-- HEADER -->
          <div style="display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px;">
            <div style="width: 30%; font-size: 12px; line-height: 1.4;">
              <div>${company?.company_name || ''}</div>
              <div>${company?.address_english || ''}</div>
              <div>CR: ${company?.cr_no || ''}</div>
              <div>VAT: ${company?.vat_no || ''}</div>
              <div>Mob: ${company?.mobile || ''}</div>
            </div>

            <div style="text-align: center;">
              ${company?.logoUrl ? `<img src="${company.logoUrl}" style="width: 100px; height: auto; margin-bottom: 5px;" />` : ""}
              <div style="font-size: 20px; font-weight: bold;">${company?.company_name || "Company"}</div>
              <div style="border: 1px solid #000; padding: 4px; margin-top: 5px;">Quotation</div>
            </div>

            <div style="width: 30%; font-size: 12px; line-height: 1.4; text-align: right;">
              <div>وزو</div>
              <div>عنوان الشركة</div>
              <div>سجل تجاري: ${company?.cr_no || ''}</div>
              <div>ضريبة القيمة: ${company?.vat_no || ''}</div>
              <div>جوال: ${company?.mobile || ''}</div>
            </div>
          </div>

          <!-- INVOICE DETAILS -->
          <div style="display: flex; justify-content: space-between; gap: 10px; margin-bottom: 15px;">
            <div style="width: 50%; padding: 10px; font-size: 12px; line-height: 1.6; border: 1px solid #000; border-radius: 5px;">
              <div><strong>Bill To:</strong> ${selectedPartyName}</div>
              <div><strong>Address:</strong> </div>
              <div><strong>Mob:</strong> ${contact}</div>
              <div><strong>VAT No:</strong> </div>
            </div>

            <div style="width: 50%; padding: 10px; font-size: 12px; line-height: 1.6; border: 1px solid #000; border-radius: 5px;">
              <div><strong>Invoice No:</strong> ${invoiceNo}</div>
              <div><strong>Date:</strong> ${date}</div>
              <div><strong>D. Note:</strong> - </div>
              <div><strong>Ref:</strong> - </div>
            </div>
          </div>

          <!-- PRODUCT TABLE -->
          <table style="width: 100%; border-collapse: collapse; margin-bottom: 15px;">
            <thead>
              <tr>
                <th style="border: 1px solid #000; padding: 6px;">SI.No</th>
                <th style="border: 1px solid #000; padding: 6px;">Description</th>
                <th style="border: 1px solid #000; padding: 6px;">Qty</th>
                <th style="border: 1px solid #000; padding: 6px;">Rate</th>
                <th style="border: 1px solid #000; padding: 6px;">Discount</th>
                <th style="border: 1px solid #000; padding: 6px;">VAT</th>
                <th style="border: 1px solid #000; padding: 6px;">Sub Total</th>
              </tr>
            </thead>
            <tbody>
              ${items
                .map(
                  (row: any, i: number) => `
                <tr>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:center;">${i + 1}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000;">${row.Item || ""}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:center;">${row.Qty || 0}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:right;">${row.Rate || 0}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:right;">${row.Dis || 0}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:right;">${row.TaxA || 0}</td>
                  <td style="border-left: 1px solid #000; border-right: 1px solid #000; text-align:right;">${row.NetV || 0}</td>
                </tr>`
                )
                .join("")}

              <!-- Empty Space -->
              <tr>
                <td colspan="7" style="border: 0.5px solid #000; height: 60px;"></td>
              </tr>
            </tbody>
          </table>

          <!-- BOTTOM TOTALS -->
          <div style="display: flex; justify-content: space-between; margin-top: 10px;">
            <div style="width: 60%; font-size: 12px;">
              <div><strong>Amount in words:</strong> </div>
              <div style="margin-top: 10px;">
                <strong>Bank Details:</strong><br/>
                Bank: ${company?.bank_name || ''}<br/>
                A/c Name: ${company?.account_name || ''}<br/>
                A/c No: ${company?.account_number || ''}<br/>
                IBAN: ${company?.iban || ''}
              </div>
            </div>

            <div style="width: 35%;">
              <table style="width: 100%; border-collapse: collapse;">
                <tr>
                  <th style="border: 1px solid #000; padding: 6px;">Total</th>
                  <td style="border: 1px solid #000; padding: 6px; text-align:right;">${totalTotal.toFixed(2)}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #000; padding: 6px;">Discount</th>
                  <td style="border: 1px solid #000; padding: 6px; text-align:right;">${totalDiscountAmt.toFixed(2)}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #000; padding: 6px;">Net Amount</th>
                  <td style="border: 1px solid #000; padding: 6px; text-align:right;">${netAmount.toFixed(2)}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #000; padding: 6px;">VAT (15%)</th>
                  <td style="border: 1px solid #000; padding: 6px; text-align:right;">${totalTaxAmt.toFixed(2)}</td>
                </tr>
                <tr>
                  <th style="border: 1px solid #000; padding: 6px;">Grand Total</th>
                  <td style="border: 1px solid #000; padding: 6px; text-align:right;">${totalNet.toFixed(2)}</td>
                </tr>
              </table>
            </div>
          </div>

          <!-- FOOTER -->
          <div style="display: flex; justify-content: space-between; margin-top: 40px; font-size: 12px;">
            <div><strong>Salesman:</strong> __________</div>
            <div><strong>Received By:</strong> __________</div>
          </div>

        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.onload = () => printWindow.print();
  } catch (err) {
    console.error("Print Error:", err);
    alert("Print failed");
  }
};


  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">{t("orderList")}</h4>
          <select
            className="form-select w-auto"
            value={filter}
            onChange={handleFilterChange}
          >
            <option value="all">{t("allOrders")}</option>
            <option value="confirmed">{t("confirmedOrders")}</option>
            <option value="pending">{t("pendingOrders")}</option>
          </select>
        </div>

        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th>{t("billNo")}</th>
                <th>{t("partyName")}</th>
                <th>{t("date")}</th>
                <th>{t("total")}</th>
                  <th>{t("actions")}</th> {/* Added new column header */}
              </tr>
            </thead>
            <tbody>
              {orders.length > 0 ? (
                orders.map((order, index) => (
                  <tr
                    key={index}
                    onClick={() => navigate(`/order/order-details/${order.BillNo}`)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>{order.BillNo}</td>
                    <td>{order.BillPartyName}</td>
                    <td>{order.BillDate}</td>
                    <td>{order.BillNetTotalField}</td>
                     <td>
                      {/* Added Print button (you can later control visibility with status) */}
                      <button
  className="btn btn-sm btn-primary"
  onClick={(e) => handlePrint(e, order.BillNo)}
>
  <i className="ti ti-printer"></i> {t("print")}
</button>

                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No orders found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default Order;
